module.exports = __webpack_public_path__ + "img/bg_mobile.5733ce22.png";